import React, { Fragment, useContext, useEffect, useState } from 'react';
import Toast from '../helpers/Toast';
import Spinner from '../helpers/Spinner';
import { AuthContext } from '../../context/Auth.context';
import { partialPaymentsInfo, getCurrentCut, addPartialTicket, cancelPartialPayment, updateCutAlert } from '../services/salesServices';
import { dateFormat } from '../functions/dateFormat';
import { getActualDate } from '../functions/getActualDate';
import { isElectron } from '../functions/isElectron';
import { FakeIpcRenderer } from '../helpers/FakeIpcRenderer';
import { useIsOnline } from 'react-use-is-online';
import { getID } from '../functions/getID';
import { Link, useNavigate } from 'react-router-dom';

let ipcRenderer = FakeIpcRenderer;

if (isElectron()) {
    ipcRenderer = window.require("electron").ipcRenderer;
    ipcRenderer.removeAllListeners('save-sales-json-reply');
    ipcRenderer.removeAllListeners('get-sales-json-reply');
    ipcRenderer.removeAllListeners('generate-ticket-reply');
}

const PartialPayments = () => {
    let navigate = useNavigate();
    const { isOnline } = useIsOnline();
    const cartInitialValue = { productList: [], payment: 0, total: 0, discount: 0, paymentMethod: 1, change: 0, notes: '', split: false, payInDlls: false, paymentDlls: 0, changeDlls: 0, totalDlls: 0, partial: false, secondPaymentMethod: 0, secondPayment: 0, date: '', ticketPartialPayment: null, previousTicket: null };
    const [partialPayments, setPartialPayments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pages, setPages] = useState([]);
    const [first_item, setFirst_item] = useState(1);
    const [last_item, setLast_item] = useState(1);
    const [total_current, setTotal_current] = useState(1);
    const [list, setList] = useState([]);
    const { state, CheckResponse } = useContext(AuthContext);
    const [current_page, setCurrent_page] = useState(1);
    const [cart, setCart] = useState(cartInitialValue);
    const [modalPayment, setModalPayment] = useState(false);
    const [modalPrint, setModalPrint] = useState(false);
    const [tipoDeCambio, setTipoDeCamio] = useState(16);
    const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(0);
    const [paymentList, setPaymentList] = useState([]);
    const [subtotal, setSubTotal] = useState(0);
    const [ticket_details, getTicketDetails] = useState([]);
    const [paymentTypeList, setPaymentTypeList] = useState([]);
    const [current_paymet, setCurrentPayment] = useState([]);
    const [modal_cancel_payment_preview, setModalCancelPaymentPreview] = useState(false);
    const [is_selected_payment, setIsSelectedPayment] = useState(false);
    const [date_from, setDateFrom] = useState("");
    const [date_to, setDateTo] = useState("");
    const [show_paid, setShowPaid] = useState(false);
    const [search_text, setSearchText] = useState("");
    const [clean_filter, setCleanFilter] = useState(false);
    const [cancel_related, setCancelRelated] = useState(false);
    const [currentCut, setCurrentCut] = useState({});

    const loadSaleItems = () => {
        if (isOnline) {
            checkCurrenntCut();
            setTimeout(function () {
                if (isElectron()) {
                    getPartials();
                } else {
                    getPartials();
                }
            }, 1000);

        } else {
            getLocaljson();
        }

        // const localSaleItems = localStorage.getItem('saleitems');
        // if(isJson(localSaleItems)){
        //     const localData = JSON.parse(localSaleItems);
        //     console.log('loaded from local');
        //     setSelectedCategory(localData.data[0].name);
        //     setSaleItems(localData.data);
        //     setLastUpdate(localData.delivered);
        //     setPaymentList(localData.payments);
        //     setCart({ ...cart, paymentMethod: localData.payments[0].id });
        //     setDefaultPaymentMethod(localData.payments[0].id);
        //     setLoading(false);
        // }else{
        //     loadSaleItemsFromWeb();
        // }
    }

    const checkCurrenntCut = () => {
        getCurrentCut(state.auth).then(data => {
            CheckResponse(data);
            if (data.code == 200) {
                // localStorage.setItem('saleitems',JSON.stringify(data));
                if (data.active) {
                    setCurrentCut({ ...data.current });
                } else {
                    showToast('Oops!', 'No hay un corte!', 'danger');
                    navigate('/cuts', { state: { previousPath: 'partial-payments', pathName: 'Pagos'} });
                }
            } else {
                showToast('Oops!', 'Algo salio mal 1!', 'danger');
            }
        });
    }

    const cutAlertUpdate = () => {
        if (isOnline) {
            //agregar toast de carga
            const loadingListId = getID();
            setList([...list, {
                id: loadingListId,
                title: 'Actualizando corte',
                description: '',
                type: "info",
                loading: true,
                short: true,
                delete: false
            }]);
            updateCutAlert(state.auth, currentCut).then(data => {
                CheckResponse(data);
                //quitar toast de carga
                const listItemIndex = list.findIndex(e => e.id === loadingListId);
                list.splice(listItemIndex, 1);
                setList([...list]);
                if (data.code == 200) {
                    setCurrentCut({ ...data.cut });

                    showToast('Hecho!', 'Corte actualizado!', 'success');
                } else {
                    showToast('Oops!', 'Algo salio mal 2!', 'danger');
                }

            });
        } else if (!isOnline && isElectron()) {
            setCurrentCut({ ...currentCut, alerts: 0 });
            showToast('Hecho!', 'Corte actualizado!', 'success', 3);
        }

    }

    useEffect(() => {
        if (currentCut.alerts > 0) {
            setList([...list, {
                id: getID(),
                title: `Se alcanzo el limite de $${parseFloat(currentCut.limit).toLocaleString()}!!`,
                description: `Favor de guardar en la caja de seguridad`,
                type: "warning",
                action: cutAlertUpdate,
                linkDesc: "Guardado, ya no mostrar notificacion!",
                delete: 10
            }]);
        }
    }, [currentCut]);

    const changeDiscount = (d) => {
        let disc = d;
        if (d > 100) disc = 100;

        if (d < 0) disc = 0;
        setCart({ ...cart, discount: disc });
    }

    const numberPrice = (n) => {
        return parseFloat(n).toFixed(2);
        // return parseFloat(newN);
    }

    const showToast = (t, d, tt) => {
        setList([...list, {
            id: Math.floor((Math.random() * 101) + 1),
            title: t,
            description: d,
            type: tt
        }]);
    }

    useEffect(() => {
        setLoading(true);
        loadSaleItems();
    }, [current_page, list, show_paid, clean_filter]);

    useEffect(() => {
        console.log(search_text, date_from, date_to)
        if (clean_filter && (search_text || date_from || date_to)) {
            setCleanFilter(false);
        }
    }, [search_text, date_from, date_to, clean_filter]);

    useEffect(() => {
        let newTotal = subtotal;

        if (subtotal > 0) {

            if (cart.discount > 0) {
                newTotal = newTotal - (newTotal * (cart.discount / 100));
            }

            let change = (parseFloat(cart.payment) + parseFloat(parseFloat(cart.secondPayment))) - parseFloat(newTotal);

            let newTP = tipoDeCambio > 0 ? (tipoDeCambio) : 1;

            if (change < 0) change = 0;
            let newTotalDlls = parseFloat((subtotal / newTP));

            if (cart.discount > 0) {
                newTotalDlls = parseFloat((newTotalDlls - (newTotalDlls * (cart.discount / 100))));
            }
            let secondPaymentDlls = 0;

            if (parseFloat(cart.secondPayment) > 0) {
                secondPaymentDlls = parseFloat(cart.secondPayment) / newTP;
            }
            var changeDlls = parseFloat(((parseFloat(cart.paymentDlls) + parseFloat(secondPaymentDlls)) - parseFloat(newTotalDlls)));

            if (changeDlls < 0) changeDlls = 0;

            if (cart.payInDlls) change = parseFloat(changeDlls) * parseFloat(newTP);

            if (change < 0.50) {
                change = 0;
            }
            if (changeDlls < 0.10) {
                changeDlls = 0;
            }

            setCart({ ...cart, total: newTotal, totalDlls: newTotalDlls, changeDlls: changeDlls, change: change });
        }

    }, [cart.payment, cart.discount, parseFloat(cart.paymentDlls), tipoDeCambio, cart.payInDlls, parseFloat(cart.secondPayment), subtotal]);

    // comunicacion con electron #######################################
    const openChasDrawer = () => {
        ipcRenderer.send("open-chash-drawer", JSON.stringify({ data: cart, config: state.config }));
    };

    const saveLocalJson = (data) => {
        ipcRenderer.send("save-sales-json", data);
    };

    const getLocaljson = () => {
        ipcRenderer.send("get-sales-json", true);
    };

    const generateTicket = () => {
        ipcRenderer.send("generate-ticket", JSON.stringify({ data: cart, config: state.config }));
    };
    // comunicacion con electron #######################################

    const getPartials = () => {
        cleanCart();

        let filter_data = '';
        if (date_from && date_to && search_text) {
            filter_data = date_from + '/' + date_to + '/' + search_text + '/';
        } else if (date_from && date_to) {
            filter_data = date_from + '/' + date_to + '/0/';
        } else if (search_text) {
            filter_data = '0/0/' + search_text + '/';
        } else {
            filter_data = '0/0/0/';
        }

        if (clean_filter) filter_data = '0/0/0/';

        show_paid ? filter_data = filter_data + '1/' : filter_data = filter_data + '0/';

        partialPaymentsInfo(state.auth, 10, current_page, filter_data).then(data => {
            CheckResponse(data);
            console.log(data);
            if (data.code == 200) {
                setPartialPayments(data.payments);
                setPages(data.pages);
                setFirst_item(data.first_item);
                setLast_item(data.last_item);
                setCurrent_page(data.current_page);
                setTotal_current(data.total_current);
                setPaymentTypeList(data.payment_types);
                setDefaultPaymentMethod(data.payment_types[0].id);
            } else {
                showToast('Oops!', 'Algo salio mal 3!', 'danger');
            }
            setLoading(false);
        })
    }

    const isJson = (str) => {
        try {
            if (str.length > 1) {

                JSON.parse(str);
            }
        } catch (e) {
            return false;
        }
        return true;
    }

    const turnDllsOn = () => {
        const newTP = tipoDeCambio > 0 ? parseFloat(tipoDeCambio) : 1;
        let newTotalDlls = subtotal / newTP;
        if (cart.discount > 0) {
            newTotalDlls = newTotalDlls - (newTotalDlls * (cart.discount / 100));
        }

        let changeDlls = parseFloat(cart.paymentDlls) - parseFloat(newTotalDlls);

        if (changeDlls < 0.10) changeDlls = 0;

        var change = (changeDlls * newTP);

        if (change < 0.50) {
            change = 0;
        }

        setCart({ ...cart, totalDlls: newTotalDlls, changeDlls: changeDlls, change: change, payInDlls: true });
    }

    const cancelPayment = () => {
        setModalPayment(false);
        setCart({ ...cart, productList: [], payment: 0, total: 0, discount: 0, paymentMethod: defaultPaymentMethod, change: 0, notes: '', split: false, payInDlls: false, paymentDlls: 0, changeDlls: 0, totalDlls: 0, partial: false, secondPaymentMethod: defaultPaymentMethod, secondPayment: 0, ticketPartialPayment: null, previousTicket: null });
    }

    const setActivePayment = (payment) => {
        let id_original_ticket = payment.id_ticket_partial_payment == null ? payment.id : payment.id_ticket_partial_payment;
        let payInDlls = payment.paid_amount_dlls > 0 ? true : false;
        if (payment.exchange_rate > 0)
            setTipoDeCamio(payment.exchange_rate);

        setCart({ ...cart, productList: payment.details, payment: 0, total: payment.remaining_partial_payment, discount: 0, paymentMethod: defaultPaymentMethod, change: 0, notes: '', split: false, payInDlls: false, paymentDlls: 0, changeDlls: 0, totalDlls: 0, partial: false, secondPaymentMethod: defaultPaymentMethod, secondPayment: 0, ticketPartialPayment: id_original_ticket, previousTicket: payment.id });
        setSubTotal(payment.remaining_partial_payment);
        setModalPayment(true);
        if (payInDlls)
            turnDllsOn();
    }

    const cleanCart = () => {
        setCart({ ...cart, productList: [], payment: 0, total: 0, discount: 0, paymentMethod: defaultPaymentMethod, change: 0, notes: '', split: false, payInDlls: false, paymentDlls: 0, changeDlls: 0, totalDlls: 0, partial: false, secondPaymentMethod: defaultPaymentMethod, secondPayment: 0, ticketPartialPayment: null, previousTicket: null });
    }

    const goToPrint = () => {
        const dateToCart = getActualDate();

        if (cart.payInDlls) {
            const newPayment = (tipoDeCambio * cart.paymentDlls);
            setCart({ ...cart, date: dateToCart, payment: newPayment, tipoDeCambio: tipoDeCambio });
        } else {
            setCart({ ...cart, date: dateToCart });
        }

        setModalPayment(false);
        setModalPrint(true);
    }

    const printTicket = (print) => {

        setModalPrint(false);

        if (print) {
            generateTicket();
            // enviar a imprimir el ticket con el cart y la configuracion que se imprima antes de que se guarde, si algo sale mal que se agrege a los tickets locales
        }

        if (isOnline) {
            const loadingListId = getID();
            setList([...list, {
                id: loadingListId,
                title: 'Guardando Recibo',
                description: '',
                type: "info",
                loading: true,
                short: true,
                delete: false
            }]);

            addPartialTicket(state.auth, cart, currentCut, tipoDeCambio).then(data => {
                CheckResponse(data);
                if (data.code === 200) {
                    setCurrentCut({ ...data.cut });
                    showToast('Hecho!', 'Recibo guardado!', 'success', 3);
                } else if (data.code === 502) {
                    showToast('Oops!', 'No hay un corte!', 'danger');
                }
            });
        } else {
            showToast('Recibo local', 'Se guardara al conectarse a internet', 'info', 3);
            const currentCart = cart;
            const newCut = 0;
            let total_for_withdraw = currentCart.total;
            if (currentCart.payInDlls) {
                // const pago_1_index = paymentList.findIndex((obj) => obj.id == currentCart.paymentMethod);
                // if (pago_1_index > -1) {
                //     if(paymentList[pago_1_index].count_for_cut_withdraw == 0){
                if (state.config.dlls_count_for_withdraw == 0) {
                    total_for_withdraw -= (currentCart.paymentDlls * tipoDeCambio);
                }
                //     }
                // }
            } else {
                const pago_1_index = paymentList.findIndex((obj) => obj.id == currentCart.paymentMethod);
                if (pago_1_index > -1) {
                    if (paymentList[pago_1_index].count_for_cut_withdraw == 0) {

                        total_for_withdraw -= currentCart.payment;
                    }
                }
            }

            if (currentCart.split) {
                const pago_2_index = paymentList.findIndex((obj) => obj.id == currentCart.secondPaymentMethod);

                if (pago_2_index > -1) {
                    if (paymentList[pago_2_index].count_for_cut_withdraw == 0) {
                        total_for_withdraw -= currentCart.secondPayment;
                    }
                }
            }

            newCut.total = newCut.total + currentCart.total;

            if (total_for_withdraw > 0) {
                newCut.total_for_withdraw = newCut.total_for_withdraw + total_for_withdraw;
            }

            if (newCut.total_for_withdraw > newCut.accumulated) {
                newCut.accumulated = newCut.accumulated + newCut.limit;
                newCut.alerts = 1;
            }

            localStorage.setItem('offlineCut', JSON.stringify(newCut));

            const offlineCart = localStorage.getItem('offlineCart');

            if (isJson(offlineCart) && offlineCart !== null) {
                const localData = JSON.parse(offlineCart);
                currentCart.tipoDeCambio = tipoDeCambio;
                localData.push(currentCart);
                localStorage.setItem('offlineCart', JSON.stringify(localData));

            } else {
                currentCart.tipoDeCambio = tipoDeCambio;
                const newData = [currentCart];
                localStorage.setItem('offlineCart', JSON.stringify(newData));
            }
        }
    }

    const cancelPartialPaymentModal = (payment) => {
        setCurrentPayment(payment);
        setIsSelectedPayment(true);
        setModalCancelPaymentPreview(true);
    }

    const closeCancelPaymentModal = () => {
        setCurrentPayment([]);
        setIsSelectedPayment(false);
        setModalCancelPaymentPreview(false);
    }

    const cancelPartial = () => {
        const payment = current_paymet.id;
        closeCancelPaymentModal();
        const loadingListId = getID();
        setList([...list, {
            id: loadingListId,
            title: 'Cancelando pago parcial',
            description: '',
            type: "info",
            loading: true,
            short: true,
            delete: false
        }]);
        let error = false;

        if (!error) {
            cancelPartialPayment(state.auth, payment, cancel_related).then(data => {
                CheckResponse(data);
                if (data.code == 200) {
                    showToast('Hecho!', 'Cancelado con exito', 'success');
                    // setReload((reload) => !reload)
                } else {
                    showToast('Oops!', 'Algo salio mal 4!', 'danger');
                }
            });
        }
    }

    const handleChangeDateFrom = (event) => {
        setDateFrom(event.target.value);
    };

    const handleChangeDateTo = (event) => {
        setDateTo(event.target.value);
    };

    const changueShowedPayments = () => {
        setDateFrom('');
        setDateTo('');
        setSearchText('');
        setShowPaid((prevShowSaled) => !prevShowSaled);
    }

    const handleChangeTextInput = (event) => {
        setSearchText(event.target.value);
    }

    const cleanFilter = () => {
        setDateFrom('');
        setDateTo('');
        setSearchText('');
        setCleanFilter(true);
    }

    return (
        <>
            <Toast
                toastList={list}
            />
            <h1>Pagos parciales</h1>

            <div className="row mt-2">
                <div className="col-sm-4 mt-1">
                    <label></label>
                    <input type="text" value={search_text} onChange={(e) => handleChangeTextInput(e)} className='form-control' placeholder='No. de ticket, Notas, Pago.....'></input>
                </div>
                <div className="col-sm-4 mt-1">
                    <label>De:</label>
                    <input type="date" value={date_from} onChange={(e) => handleChangeDateFrom(e)} className='form-control'></input>
                </div>
                <div className="col-sm-4 mt-1">
                    <label>A:</label>
                    <input type="date" value={date_to} onChange={(e) => handleChangeDateTo(e)} className='form-control'></input>
                </div>
                <div className="col-sm-3 mt-1">
                    <button className="btn btn-success mt-4 me-2 w-100" onClick={() => { getPartials() }}>Buscar Pagos Parciales</button>
                </div>
                <div className="col-sm-2 mt-1">
                    <button className="btn btn-secondary mt-4 me-2" onClick={() => { cleanFilter() }}>Limpiar filtro</button>
                </div>
                <div className="col-sm-2 mt-1">
                    <button className="btn btn-primary mt-4" onClick={() => changueShowedPayments()}>{show_paid ? 'Ver no pagados' : 'Ver pagados'}</button>
                </div>
            </div>

            {loading && <div className="col-sm-4 mt-1">
                <Spinner size={3} margin={4}></Spinner>
            </div>}
            {!loading && <>
                <div className="row">
                    <div className="col-sm-12 mt-4">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>No. de ticket</th>
                                    <th>Primer ticket</th>
                                    <th>Notas</th>
                                    <th>Fecha</th>
                                    <th>Tipo de Cambio</th>
                                    <th>SubTotal</th>
                                    <th>Descuento</th>
                                    <th>Total</th>
                                    <th>Pago</th>
                                    <th>Restante</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {partialPayments?.map(item =>
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.id_ticket_partial_payment}</td>
                                        <td>{item.notes}</td>
                                        <td>{dateFormat(item.created)}</td>
                                        <td>{item.exchange_rate > 0 ? 'Dlls: ' + item.exchange_rate : ''}</td>
                                        <td>{item.discount ? (item.total / (1 - (item.discount / 100))).toFixed(2) : item.total.toFixed(2)}</td>
                                        <td>{item.discount}</td>
                                        <td>{item.total}</td>
                                        <td>{item.paid_amount}</td>
                                        <td>{item.remaining_partial_payment ? item.remaining_partial_payment.toFixed(2) : "0.00"}</td>
                                        <td>
                                            {!show_paid && <button className="btn btn-primary" onClick={() => { setActivePayment(item) }}>Pagar</button>}
                                            {state.auth.type != 3 && <button className="btn btn-danger ms-1" onClick={() => { cancelPartialPaymentModal(item) }}>Cancelar</button>}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <ul className="pagination">
                                    {pages.map(page =>
                                        <Fragment key={page}>
                                            {current_page === page ?
                                                <span key={page} className="page-link active me-2" style={{ "width": "40px", "textAlign": "center" }}>{page}</span>
                                                :
                                                <li key={page} className="page-page me-2" style={{ "width": "40px", "textAlign": "center" }}><a className="page-link" onClick={() => setCurrent_page(page)}>{page}</a></li>
                                            }
                                        </Fragment>
                                    )}
                                </ul>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <p className="text-sm-start mt-2">Mostrando <b>{first_item}</b> a <b>{last_item}</b> de un total de <b>{total_current}</b></p>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            <div className="modal fade show" style={{ background: "rgba(0, 0, 0, 0.8)", display: modalPayment ? 'block' : 'none' }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5">Pagar</h1>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12 text-wrap text-center">
                                        <h3>Subtotal: ${numberPrice(subtotal)} {cart.payInDlls && <>/ Subtotal Dlls: ${numberPrice(subtotal / (tipoDeCambio > 0 ? tipoDeCambio : 1))}</>}</h3>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4">
                                        <label className="form-label">Pago Parcial</label> <br></br>
                                        <button onClick={() => { setCart({ ...cart, partial: false }) }} className={`btn btn ${!cart.partial ? 'btn-primary' : 'btn-outline-primary'}`} style={{ width: "45%" }} type="button">No</button>
                                        <button onClick={() => { setCart({ ...cart, partial: true }) }} className={`btn ${cart.partial ? 'btn-success' : 'btn btn-outline-success'}  ms-2`} style={{ width: "45%" }} type="button">Si</button>
                                    </div>
                                    <div className="col-sm-4">
                                        <label className="form-label">Pago en dlls</label> <br></br>
                                        <button onClick={() => { setCart({ ...cart, payInDlls: false }) }} className={`btn btn ${!cart.payInDlls ? 'btn-primary' : 'btn-outline-primary'}`} style={{ width: "45%" }} type="button">No</button>
                                        <button onClick={() => { turnDllsOn() }} className={`btn ${cart.payInDlls ? 'btn-success' : 'btn btn-outline-success'}  ms-2`} style={{ width: "45%" }} type="button">Si</button>
                                    </div>
                                    {cart.payInDlls && <>
                                        <div className="col-sm-4">
                                            <label className="form-label">Tipo de Camio</label>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text">$</span>
                                                <input onChange={(e) => { setTipoDeCamio(e.target.value) }} type="number" value={tipoDeCambio} className="form-control" />
                                            </div>
                                        </div>
                                    </>}

                                </div>

                                <div className="row mt-2">
                                    <div className="col-sm-4 text-wrap">
                                        <label className="form-label">Metodo de Pago</label>
                                        <select className="form-control" value={cart.paymentMethod} onChange={e => setCart({ ...cart, paymentMethod: parseInt(e.target.value) })}>
                                            <option value="0" disabled>Selecione...</option>
                                            {paymentTypeList.map(item =>
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            )}
                                        </select>
                                    </div>
                                    <div className="col-sm-4">
                                        <label className="form-label">Dividir pago</label> <br></br>
                                        <button onClick={() => { setCart({ ...cart, split: false, secondPayment: 0 }) }} className={`btn btn ${!cart.split ? 'btn-primary' : 'btn-outline-primary'}`} style={{ width: "45%" }} type="button">No</button>
                                        <button onClick={() => { setCart({ ...cart, split: true, secondPayment: 0 }) }} className={`btn ${cart.split ? 'btn-success' : 'btn btn-outline-success'}  ms-2`} style={{ width: "45%" }} type="button">Si</button>
                                    </div>
                                    <div className="col-sm-4 text-wrap">
                                        <label className="form-label">Descuento</label>
                                        <div className="input-group input-group-sm mb-3">
                                            <input max={100} onClick={() => { setCart({ ...cart, discount: 0 }) }} onChange={(e) => { changeDiscount(e.target.value) }} type="number" value={cart.discount} className="form-control" />
                                            <span className="input-group-text">%</span>
                                        </div>
                                    </div>
                                </div>

                                {/* totales en pesos */}
                                {!cart.payInDlls && <div className="row">
                                    <div className="col-sm-3 text-wrap text-center mt-3">
                                        <h5>Descuento</h5>
                                        <h5 className='mt-3'>${cart.discount > 0 ? numberPrice((subtotal * (cart.discount / 100))) : 0}</h5>
                                    </div>
                                    <div className="col-sm-3 text-wrap text-center mt-3">
                                        <h5>Total</h5>
                                        <h5 className='mt-3'>${cart.discount > 0 ? numberPrice(cart.total - (subtotal * (cart.discount / 100))) : numberPrice(cart.total)}</h5>
                                    </div>
                                    <div className="col-sm-3 text-wrap text-center mt-3">
                                        <h5>Pago</h5>
                                        <div className="input-group input-group-sm mb-3">
                                            <span className="input-group-text">$</span>
                                            <input onMouseDown={() => { setCart({ ...cart, payment: 0 }) }} onChange={(e) => { setCart({ ...cart, payment: numberPrice(e.target.value) }) }} type="number" value={cart.payment} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap text-center mt-3">
                                        <h5>Cambio</h5>
                                        <h5 className='mt-3'>${cart.change > 0 ? numberPrice(cart.change) : 0}</h5>
                                    </div>
                                </div>}

                                {/* totales en dlls */}
                                {cart.payInDlls && <div className="row">
                                    <div className="col-sm-3 text-wrap text-center mt-3">
                                        <h5>Descuento</h5>
                                        <h5 className='mt-3'>${cart.discount > 0 ? numberPrice(((subtotal / (tipoDeCambio > 0 ? tipoDeCambio : 1)) * (cart.discount / 100))) : 0}</h5>
                                    </div>
                                    <div className="col-sm-3 text-wrap text-center mt-3">
                                        <h5>Total</h5>
                                        <h5 className='mt-3'>${tipoDeCambio > 0 ? numberPrice(cart.totalDlls) : 0}</h5>
                                    </div>
                                    <div className="col-sm-3 text-wrap text-center mt-3">
                                        <h5>Pago</h5>
                                        <div className="input-group input-group-sm mb-3">
                                            <span className="input-group-text">$</span>
                                            <input onMouseDown={() => { setCart({ ...cart, paymentDlls: 0 }) }} onChange={(e) => { setCart({ ...cart, paymentDlls: e.target.value }) }} type="number" value={parseFloat(cart.paymentDlls)} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap text-center mt-3">
                                        <h5>Cambio</h5>
                                        <h5 className='mt-3'>${cart.changeDlls > 0 ? numberPrice(cart.changeDlls) : 0} Dlls o ${cart.change > 0 ? numberPrice(cart.change) : 0}</h5>
                                    </div>
                                </div>}

                                {cart.split && <div className='row mt-1'>
                                    <div className="col-sm-6 text-wrap">
                                        <label className="form-label">Segundo Metodo de Pago</label>
                                        <select className="form-control" value={cart.secondPaymentMethod} onChange={e => setCart({ ...cart, secondPaymentMethod: e.target.value })}>
                                            <option value="0" disabled>Selecione...</option>
                                            {paymentTypeList.map(item =>
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            )}
                                        </select>
                                    </div>
                                    <div className="col-sm-6 text-wrap text-center">
                                        <label>Segundo Pago en Pesos</label>
                                        <div className="input-group mb-3">
                                            <span className="input-group-text">$</span>
                                            <input onMouseDown={() => { setCart({ ...cart, secondPayment: 0 }) }} onChange={(e) => { setCart({ ...cart, secondPayment: e.target.value }) }} type="number" value={parseFloat(cart.secondPayment)} min={0} className="form-control" />
                                        </div>
                                    </div>
                                </div>}

                                {/* dinero en pesos*/}
                                {!cart.payInDlls && <div className="row mt-2">
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, payment: (cart.discount > 0 ? (cart.total - (subtotal * (cart.discount / 100))) : (subtotal) + cart.payment) }) }} className="btn btn-primary btn-lg" type="button">{cart.discount > 0 ? numberPrice(cart.total - (subtotal * (cart.discount / 100))) : numberPrice(cart.total)}</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, payment: (5 + cart.payment) }) }} className="btn btn-primary btn-lg" type="button">5</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, payment: (10 + cart.payment) }) }} className="btn btn-primary btn-lg" type="button">10</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, payment: (20 + cart.payment) }) }} className="btn btn-primary btn-lg" type="button">20</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, payment: (50 + cart.payment) }) }} className="btn btn-primary btn-lg" type="button">50</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, payment: (100 + cart.payment) }) }} className="btn btn-primary btn-lg" type="button">100</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, payment: (200 + cart.payment) }) }} className="btn btn-primary btn-lg" type="button">200</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, payment: (500 + cart.payment) }) }} className="btn btn-primary btn-lg" type="button">500</button>
                                        </div>
                                    </div>
                                </div>}

                                {/* dinero en dlls*/}
                                {cart.payInDlls && <div className="row mt-2">
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, paymentDlls: numberPrice(((cart.discount > 0 ? (subtotal - (subtotal * (cart.discount / 100))) : subtotal) / (tipoDeCambio > 0 ? tipoDeCambio : 1)) + parseFloat(cart.paymentDlls)) }) }} className="btn btn-success btn-lg" type="button">{numberPrice((cart.discount > 0 ? (subtotal - (subtotal * (cart.discount / 100))) : subtotal) / (tipoDeCambio > 0 ? tipoDeCambio : 1))}</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, paymentDlls: (1 + parseFloat(cart.paymentDlls)) }) }} className="btn btn-success btn-lg" type="button">1</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, paymentDlls: (2 + parseFloat(cart.paymentDlls)) }) }} className="btn btn-success btn-lg" type="button">2</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, paymentDlls: (5 + parseFloat(cart.paymentDlls)) }) }} className="btn btn-success btn-lg" type="button">5</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, paymentDlls: (10 + parseFloat(cart.paymentDlls)) }) }} className="btn btn-success btn-lg" type="button">10</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, paymentDlls: (20 + parseFloat(cart.paymentDlls)) }) }} className="btn btn-success btn-lg" type="button">20</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, paymentDlls: (50 + parseFloat(cart.paymentDlls)) }) }} className="btn btn-success btn-lg" type="button">50</button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 text-wrap mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setCart({ ...cart, paymentDlls: (100 + parseFloat(cart.paymentDlls)) }) }} className="btn btn-success btn-lg" type="button">100</button>
                                        </div>
                                    </div>
                                </div>}

                                <div className="row">
                                    <div className="col-sm-12 text-wrap mt-2">
                                        <label className="form-label">Notas (opcional)</label>
                                        <input onChange={(e) => { setCart({ ...cart, notes: e.target.value }) }} type="text" value={cart.notes} className="form-control" />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { cancelPayment() }} className="btn btn-danger" type="button">Cancelar</button>
                                        </div>
                                    </div>
                                    <div className="col-md-8 ms-auto">
                                        <div className="d-grid gap-2">
                                            {/* pagar pesos */}
                                            {!cart.payInDlls && <button onClick={() => { goToPrint() }} className={`btn btn-success ${((cart.payment + parseFloat(cart.secondPayment)) >= cart.total || (cart.partial && (cart.payment + parseFloat(cart.secondPayment)) > 0) || (cart.discount !== 0 && cart.payment === (cart.total - (subtotal * (cart.discount / 100))))) && cart.paymentMethod != 0 ? '' : 'disabled'}`} type="button">Cobrar</button>}
                                            {/* pagar dlls */}
                                            {cart.payInDlls && <button onClick={() => { goToPrint() }} className={`btn btn-success ${(((parseFloat(cart.paymentDlls) + (parseFloat(cart.secondPayment) > 0 ? (parseFloat(cart.secondPayment) / (tipoDeCambio > 0 ? tipoDeCambio : 1)) : 0)) >= cart.totalDlls || (cart.partial & (parseFloat(cart.paymentDlls) + (parseFloat(cart.secondPayment) > 0 ? (parseFloat(cart.secondPayment) / parseFloat(tipoDeCambio > 0 ? tipoDeCambio : 1)) : 0)) > 0)) && cart.paymentMethod != 0) ? '' : 'disabled'}`} type="button">Cobrar</button>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* modal imprimir */}
            <div className="modal fade show" style={{ background: "rgba(0, 0, 0, 0.8)", display: modalPrint ? 'block' : 'none' }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">Imprimir ticket</h1>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {!isElectron() && <>
                                    <div className="row ">
                                        <div className="col-sm-12 text-center mt-1">
                                            <h4>Solo se pueden imprimir en la version de escritorio!</h4>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 mt-1">
                                            <div className="d-grid gap-2">
                                                <button onClick={() => { printTicket(false) }} className="btn btn-success" type="button">Terminar</button>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                                {isElectron() && <>
                                    <div className="row ">
                                        <div className="col-sm-12 text-center mt-1">
                                            <h3>Imprimir Ticket?</h3>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6 mt-1">
                                            <div className="d-grid gap-2">
                                                <button onClick={() => { printTicket(false) }} className="btn btn-danger" type="button">No</button>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 mt-1">
                                            <div className="d-grid gap-2">
                                                <button onClick={() => { printTicket(true) }} className="btn btn-success" type="button">Si</button>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade show" style={{ background: "rgba(0, 0, 0, 0.8)", display: modal_cancel_payment_preview ? 'block' : 'none' }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Cancelar pago parcial?</h5>
                            <button onClick={() => { closeCancelPaymentModal() }} type="button" className="btn-close"></button>
                        </div>
                        <div className="modal-body">
                            <h5>No. de ticket</h5>
                            <p>{is_selected_payment && current_paymet.id}</p>
                            <h5>Fecha</h5>
                            <p>{is_selected_payment && dateFormat(current_paymet.created)}</p>
                            <h5>Pago</h5>
                            <p>{is_selected_payment && current_paymet.paid_amount}</p>
                            {!current_paymet.id_ticket_partial_payment && current_paymet.related_tickets?.length > 0 && <>
                                <h5>Tickets Relacionados</h5>
                                {current_paymet.related_tickets?.map(item =>
                                    <p>{item.id}</p>
                                )}
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={'C' + current_paymet.id}
                                    onChange={() => setCancelRelated((prevCancelRelated) => !prevCancelRelated)}
                                    checked={cancel_related}
                                />
                                <label className="form-check-label ms-1" htmlFor={'C' + current_paymet.id}>
                                    Cancelar tickets relacionados
                                </label>
                            </>}
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => { closeCancelPaymentModal() }} className="btn btn-primary" type="button">Cerrar</button>
                            <button type="button" onClick={() => { cancelPartial() }} className="btn btn-danger">Confirmar</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PartialPayments;